<div class="toggler special-{{ special }}" [class.open]="open" appTransitionPreventor>
  <div class="toggler-header-container size-{{ headerSize }} hover-color-{{ hoverColor }}" (click)="toggle()">
    <div class="toggler-header color-{{ color }}">
      <div class="toggler-header-icon icon-size-{{ iconSize }}" *ngIf="!hideIcon && iconPosition === 'left'">
        <app-svg src="/assets/icons/stroke/arrow-down.svg"></app-svg>
      </div>
      <div class="header-content">
        <ng-content select="[togglerHeader]"></ng-content>
      </div>
      <div class="toggler-header-icon icon-size-{{ iconSize }}" *ngIf="!hideIcon && iconPosition === 'right'">
        <app-svg src="/assets/icons/stroke/arrow-down.svg"></app-svg>
      </div>
    </div>
    <ng-content select="[togglerHeaderExtra]"></ng-content>
  </div>
  <div class="toggler-body padding-{{ bodyPadding }}" #togglerBody [style.height]="bodyHeight" appTransitionPreventor>
    <ng-content select="[togglerBody]"></ng-content>
  </div>
</div>
